import { useEffect, useRef } from 'react'
import { io, Socket } from 'socket.io-client'

export type NotificationClientOptions = {
  server: string
  onMessage: (
    message: string,
    messageType: 'success' | 'warning',
  ) => void | Promise<void>
}

export function useNotification(options: NotificationClientOptions) {
  const socketRef = useRef<Socket>()

  useEffect(() => {
    if (!socketRef.current) {
      socketRef.current = io(options.server ?? '/', {
        query: {},
        transports: ['websocket'],
        reconnection: true,
        autoConnect: false,
      })
    }

    socketRef.current.on('connect', () => {
      console.info('connected push server')
    })

    socketRef.current.on('disconnect', () => {
      console.info('disconnect push server')
    })

    socketRef.current.on('error', error => {
      console.error(error)
    })

    socketRef.current.on('message', payload => {
      try {
        if (payload === 'wslogout') {
          socketRef.current?.close()
          // On logout, redirect to login page
          globalThis.location.replace('/iaas/auth/login')
          return
        }

        const obj = JSON.parse(payload)
        if (!obj.success || !obj.action || obj.ignore_alert) {
          return
        }
        const type = obj.success === true ? 'success' : 'warning'
        // if (obj.notes && obj.notes.endsWith('type=itsm')) {
        //   if (obj.broadcast === true && obj.user_id === '') {
        //     store.dispatch('getAllOpenWorkflowKeys')
        //   }
        //   store.dispatch('app/fetchWorkflowStatistics')
        //   if (obj.notes.startsWith('priority=silence')) {
        //     return
        //   }
        // }
        // message[type](obj.action)
        options.onMessage(obj.action, type)
      } catch (error) {
        console.log('error: ' + payload + ' error: ' + error)
      }
    })
    return () => {
      socketRef.current?.off('error')
      socketRef.current?.off('message')
      socketRef.current?.off('connect')
      socketRef.current?.off('disconnect')
      socketRef.current?.disconnect()
    }
  }, [options])
}
